export { onCreateApp };
import { createPinia } from 'pinia';
const onCreateApp = (pageContext) => {
    installPinia(pageContext);
};
function installPinia(pageContext) {
    const pinia = createPinia();
    pageContext.app.use(pinia);
    Object.assign(pageContext, { pinia });
}
